import { Suspense } from "react";
import { Route, Routes, Navigate, Outlet, Link } from "react-router-dom";
import { Loading } from "./UI/Loading";
import { observer, inject } from "mobx-react";
import {
  Login,
  OPT,
  Lobby,
  ScreenType,
  Messages,
  Docs,
  Accounts,
  Contacts,
  Projects,
  Tenants,
  ChoosingTenants,
  NewPlan,
  PageNotFound,
  Unauthorized,
  MobileLobby,
  MobileDoc,
  MobileMessage,
  MobileContacts,
  MobileRepairPage,
  LicenseUpdateForm,
  AdminPassword,

} from "./pages";
import Tenant from "./pages/Tenant";
import Admin from "./pages/Admin";
import NewApply from "./components/Applies/NewApply";
import NewDefect from "./components/MobileNewDefect";
import MobileRepairPagesMessages from "./components/MobileRepairPagesMessages";
import RepairPages from "./pages/RepairPages";
import NewNote from "./pages/NewNote";
import NewRepairPage from "./pages/NewRepairPage";
import { Role } from "./stores/userStore";
import Bedek from "./pages/Bedek";
import { useMobile } from "./utils/mobile";
import RepairMessages from "./components/RepairMessages";

const ProtectedRoute = ({ isAllowed, redirectPath = "/401", children }) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
};

const AppRoutes = (props) => {
  const userStore = props.userStore;

  const isMobile = useMobile();

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route
          element={
            <ProtectedRoute
              isAllowed={userStore.isAuthenticated && userStore.isOtpVerify}
            />
          }
        >
          <Route element={<Tenant />}>
            <Route
              path="/tenant/lobby"
              element={isMobile ? <MobileLobby /> : <Lobby />}
            />
            <Route path="/tenant/messages" element={<Messages />} />
            <Route path="/tenant/docs" element={<Docs />} />
            <Route path="/tenant/account" element={<Accounts />} />
            <Route path="/tenant/contacts" element={<Contacts />} />
            <Route
              path="/tenant/choosing-tenants"
              element={<ChoosingTenants />}
            />
            <Route path="/tenant/new-plan" element={<NewPlan />} />
            <Route path="/tenant/applies" element={<RepairPages />} />
            <Route path="/tenant/new-apply" element={<NewNote />} />

            {/* {!!isMobile && (
              <Route path="/tenant/repair_messages" element={<RepairMessages />} />
            )} */}
            {!isMobile && (
              <Route
                path="/tenant/new-repair-page"
                element={<NewRepairPage />}
              />
            )}
            <Route
              path="/tenant/calendly"
              render={() =>
              (window.location =
                "https://calendly.com/oauth/authorize?client_id=yJLIbpY-ZkYyHmmXHS4MZYDBLBe43OHsq_fYX26IZQo&response_type=code&redirect_uri=http://localhost:3001/bedek/applies")
              }
            />
          </Route>
          <Route element={<Bedek />}>
            <Route
              path="/bedek/applies"
              element={<RepairPages bedek={true} />}
            />
            {!isMobile && (
              <Route
                path="/bedek/new-repair-page"
                element={<NewRepairPage />}
              />
            )}
          </Route>
          <Route element={<ProtectedRoute isAllowed={!!isMobile} />}>
            <Route path="/tenant/message" element={<MobileMessage />} />
            <Route path="/tenant/apply" element={<MobileRepairPage />} />
            <Route path="/bedek/apply" element={<MobileRepairPage bedek={true} />} />
            <Route path="/tenant/doc" element={<MobileDoc />} />
            <Route path="/bedek/new-repair-page" element={<NewApply />} />
            <Route path="/tenant/new-repair-page" element={<NewApply />} />
            <Route path="/bedek/mobile-new-defect" element={<NewDefect />} />
            <Route path="/tenant/mobile-new-defect" element={<NewDefect />} />
            <Route
              path="/tenant/mobile_contacts"
              element={<MobileContacts />}
            />
            <Route path="/bedek/repair_messages" element={<RepairMessages />} />
            <Route path="/tenant/repair_messages" element={<RepairMessages />} />
            <Route path="/tenant/repair_messages_list" element={<MobileRepairPagesMessages />} />

          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={
                  userStore.userDetails.role === Role.Admin &&
                  userStore.isOtpVerify === true
                }
              />
            }
          >
            <Route element={<Admin />}>
              <Route
                path="/admin/projects"
                element={<Projects />}
                replace={true}
              />
              <Route path="/admin/projects/list" element={<Projects />} />
              <Route
                path="/admin/:project/:env/:bedek/tenants"
                element={<Tenants />}
              />
              <Route
                path="/admin/:project/:env/:bedek/tenants/list"
                element={<Tenants />}
              />
              <Route
                path="/admin/license-update"
                element={<LicenseUpdateForm />}
              />
            </Route>
          </Route>
        </Route>
        <Route
          key="login_tenant"
          path="/tenants/login"
          element={<Login type={ScreenType.LOGIN_TENANT} />}
        />
        <Route
          key="login_admin"
          path="/admin/login"
          element={<Login type={ScreenType.LOGIN_ADMIN} />}
        />
        <Route
          exact
          key="opt_tenant"
          path="/tenants/opt"
          element={<OPT type={ScreenType.LOGIN_TENANT} />}
        />
        <Route
          exact
          key="opt_admin"
          path="/admin/opt"
          element={<OPT type={ScreenType.LOGIN_ADMIN} />}
        />
        <Route
          exact
          key="forgot_password_admin"
          path="/forgot_password_admin"
          element={<Login type={ScreenType.FORGOT_PASSWORD_ADMIN} />}
        />
        <Route
          exact
          key="new_password_admin"
          path="/new_password_admin"
          element={<Login type={ScreenType.NEW_PASSWORD_ADMIN} />}
        />
        <Route
          exact
          key="create_password_admin"
          path="/admin/create-password"
          element={<AdminPassword type={ScreenType.CREATE_PASSWORD_ADMIN} />}
        />
        <Route
          exact
          key="enter_password_admin"
          path="/admin/enter-password"
          element={<AdminPassword type={ScreenType.ENTER_PASSWORD_ADMIN} />}
        />
        <Route exact key="404" path="/404" element={<PageNotFound />} />
        <Route exact key="401" path="/401" element={<Unauthorized />} />
        <Route
          path="/"
          element={<Navigate to="/tenants/login" replace={true} />}
        />
        <Route
          path="*"
          element={<Navigate to="/tenants/login" replace={true} />}
        />
      </Routes>
      <Link to={"/404"} style={{ display: "none" }}>
        linkTo404
      </Link>
      <Link to={"/401"} style={{ display: "none" }}>
        linkTo401
      </Link>
      <Link to={"/admin/login"} style={{ display: "none" }}>
        linkToLoginAdmin
      </Link>

      <Link to={"/admin/opt"} style={{ display: "none" }}>
        adminOpt
      </Link>
      <Link to={"/tenants/opt"} style={{ display: "none" }}>
        optTenant
      </Link>
      <Link to={"/tenants/login"} style={{ display: "none" }}>
        linkToLoginTenants
      </Link>
      <Link to={"/tenant/lobby"} style={{ display: "none" }}>
        linkTolobby
      </Link>
      <Link to={"/tenant/messages"} style={{ display: "none" }}>
        linkToMessages
      </Link>
      <Link to={"/tenant/docs"} style={{ display: "none" }}>
        linkToDocs
      </Link>
      <Link to={"/tenant/accounts"} style={{ display: "none" }}>
        linkToAccounts
      </Link>
      <Link to={"/tenant/contacts"} style={{ display: "none" }}>
        linkToContacts
      </Link>
      <Link to={"/bedek/applies"} style={{ display: "none" }}>
        linkToBedekApplies
      </Link>
      <Link to={"/tenant/applies"} style={{ display: "none" }}>
        linkToTenantApplies
      </Link>
      <Link to={"/tenant/new-apply"} style={{ display: "none" }}>
        linkToNewApply
      </Link>
      <Link to={"/tenant/new-repair-page"} style={{ display: "none" }}>
        linkToTenantNewRepairPage
      </Link>
      <Link to={"/admin/projects"} style={{ display: "none" }}>
        linkToAdminProjects
      </Link>
      <Link to={"/bedek/new-repair-page"} style={{ display: "none" }}>
        linkToBedekNewRepairPage
      </Link>
    </Suspense>
  );
};

export default inject("userStore")(observer(AppRoutes));
